export default "__VITE_ASSET__DehHXGR3__"